// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2":"038ba49a","6629":"f98c83d5","8874":"441051bd","8966":"84b5d158"}[chunkId] + ".js";
};